/***********************************************************************************************
 * Pipe to replace pipees with line breaks
 *
 * pipe2br은 char2br과는 다르게 </a>안의 /는 <br />로 바꾸지 않는다.
 * 정확하게는 / 앞에 <가 있으면 변경을 무시한다.
 *
 * @file pipe2br.pipe.ts
 * @module pipe2brPipe
 * @category Pipe
 *
 * Copyright (c) 2023. 듣고 배우는 한국어 프로젝트.
 * by 박주형
 **********************************************************************************************/
import { Pipe, PipeTransform } from '@angular/core';
import {WORD_SEPARATOR_LINE} from "../../defines/gukeo.const";


@Pipe({
  name: 'pipe2br'
})
export class Pipe2brPipe implements PipeTransform {

  transform(content: string | null | undefined): string | null {
    return content ? content.replaceAll(WORD_SEPARATOR_LINE, '<br />') : null;
  }

}
